import styled from 'styled-components';
import { Paper } from '@mui/material';
import { colors, mixins } from '../../customComponents/css';

export const CardLink = styled(Paper)`
  text-align: center;
  font-size: 18px;
  padding: 32px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  figure {
    margin-bottom: 16px;
  }

  & * {
    cursor: pointer;
  }

  &:hover {
    background-color: ${colors.colorGrey05};
  }
`;

export const DetailItem = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  .icon {
    padding-right: ${mixins.pxToRem(5)};
  }
`;

export const cellStyle = {
  borderBottom: `1px solid ${colors.colorGrey04}`,
  paddingBottom: '10px',
  paddingTop: '10px',
  textAlign: 'center'
};
